/**
 * Client-side access gate for the PurpleDoor section.
 *
 * Visiting /purpledoor/unlock?code=opensesame writes the code into
 * localStorage; every /purpledoor page then checks for it (see
 * usePurpleDoorAccess) and redirects to "/" when it is missing.
 *
 * NOTE: this only "hides" the section. It is client-side and trivially
 * bypassable by anyone who reads the bundle or sets localStorage by hand.
 */

const ACCESS_CODE = "opensesame";
const ACCESS_STORAGE_KEY = "pd-access";

export function hasPurpleDoorAccess() {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(ACCESS_STORAGE_KEY) === ACCESS_CODE;
}

export function grantPurpleDoorAccess() {
    window.localStorage.setItem(ACCESS_STORAGE_KEY, ACCESS_CODE);
}

export { ACCESS_CODE };
